// Configuración de la moneda actual
window.shopCurrency = Shopify.currency.active;
window.currentCurrency = Shopify.currency.active;

// Asegurarse de que los precios se muestren en la moneda correcta
document.addEventListener('DOMContentLoaded', function() {
  console.log('currency-handler.js: Initializing...');
  console.log('Current currency:', window.currentCurrency);

  if (window.shopCurrency !== window.currentCurrency) {
    updatePrices();
  }

  // Modificar para escuchar todos los selectores de moneda
  const currencySelectors = document.querySelectorAll('[data-currency-selector]');
  currencySelectors.forEach(selector => {
    selector.addEventListener('change', function(e) {
      e.preventDefault();
      window.currentCurrency = this.value;
      
      console.log('Currency changed to:', window.currentCurrency);
      
      // Si el selector tiene el atributo data-form-submit, enviar el formulario
      if (this.hasAttribute('data-form-submit')) {
        const form = this.closest('form');
        if (form) {
          const scrollPosition = window.scrollY;
          const scrollInput = form.querySelector('[data-scroll-position]');
          if (scrollInput) {
            scrollInput.value = `${scrollInput.value}#scroll=${scrollPosition}`;
          }
          form.submit();
        }
      } else {
        // Solo actualizar precios sin recargar la página
        updatePrices();
      }
    });
  });
});

function updatePrices() {
  console.log('updatePrices called – current currency:', window.currentCurrency);

  // Actualizar precios generales
  const priceElements = document.querySelectorAll('[data-price]');
  priceElements.forEach(element => {
    const originalPrice = element.getAttribute('data-original-price');
    if (originalPrice) {
      const formatted = formatMoney(originalPrice);
      element.innerHTML = formatted;
      console.log('Updated price element to:', formatted);
    }
  });

  // Actualizar carrito si existe
  if (CartEvents && CartEvents.updateCart) {
    CartEvents.updateCart();
  }
}

// Añadir método global para formatear precios
window.formatMoney = formatMoney;

function formatMoney(cents) {
  const amount = cents / 100;
  const currency = Shopify.currency.active || 'USD';
  const locale = Shopify.locale || 'en-US';

  try {
    // Preferred: Intl.NumberFormat – includes symbol automatically
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const formatted = formatter.format(amount);
    console.log('Intl formatted price:', formatted);
    return formatted;
  } catch (e) {
    console.warn('Intl.NumberFormat failed for currency', currency, e);
    
    // Fallback: manual formatting with symbol
    const symbol = getCurrencySymbol(currency) || '$';
    const numberFormatted = amount.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    return symbol + numberFormatted;
  }
}

// Helper to get symbol if Intl fails
function getCurrencySymbol(currencyCode) {
  const symbols = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'CAD': 'C$',
    'AUD': 'A$',
    'JPY': '¥',
    'CNY': '¥',
    'INR': '₹',
    'BRL': 'R$',
    'MXN': 'MX$'
    // Add more as needed
  };
  return symbols[currencyCode] || currencyCode;
}